var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"inline-flex bg-fuchsia-500 text-white rounded-full h-10 text-lg px-6 justify-center items-center"},[_vm._v(_vm._s(this.content))])}
var staticRenderFns = []

export { render, staticRenderFns }